import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes(rbacActions.DeleteMeter)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateMeter)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Meters')}
            tools={useTools()}
        />
    );
};
